import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad, Route, UrlSegment, UrlTree } from '@angular/router';

// Auth Services
import { AuthService } from '../services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanLoad {
    constructor(
        private router: Router,
        private authService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.verifyAccess(state.url);
    }

    canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        let stateUrl = '';
        segments.forEach(element => {
            stateUrl += `/${element.path}`;
        });
        return this.verifyAccess(stateUrl);
    }

    private verifyAccess(stateUrl: any) {
        this.authService.returnUrl = stateUrl;
        const currentUser = this.authService.currentUserValue;
        if (currentUser) {
            // logged in so return true
            this.authService.chatConnect();
            return true;
        }

        return this.authService.getUser().pipe(
            tap(user => { this.authService.saveUserToLocalStorage(user); this.authService.chatConnect(); }),
            map(data => true),
            catchError((err) => {
                if (!this.authService.returnUrl)
                    this.router.navigate(['login']);
                else
                    this.router.navigate(['login'], { queryParams: { returnUrl: this.authService.returnUrl } });
                return throwError(err);
            })
        );
    }


}
